export default "__VITE_ASSET__CjU29LFQ__"